<adapt-dialog [maxWidth]="600">
    <h3 adapt-dialog-title>Add progress products to an organisation</h3>

    <div adapt-dialog-content
         class="d-flex flex-column gap-3">
        <div>
            <label>Organisation</label>
            <adapt-select-organisation [showClearButton]="false"
                                       (organisationChange)="organisation = $event"
                                       sort="name"></adapt-select-organisation>
        </div>

        <div>
            <adapt-select-progress-products #progressProductSelect
                                            [(progressProductIds)]="productsToAdd"
                                            [organisation]="organisation"></adapt-select-progress-products>
        </div>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [saveIsDisabled]="!organisation || productsToAdd.length === 0 || progressProductSelect.existingProducts.length > 0"
                                   [saveBlockingClick]="saveAndClose"
                                   (cancelClick)="cancel()"></adapt-standard-dialog-buttons>
</adapt-dialog>
